<template>
  <mdb-card class="animated zoomIn" wide>
    <mdb-view hover cascade>
      <a @click="goToAlbum">
        <mdb-card-image :src="cover.src" :alt="cover.alt" class="album-cover"></mdb-card-image>
        <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
      </a>
    </mdb-view>
    <mdb-card-body class="text-center pb-0" cascade>

      <mdb-card-title>
        <strong>{{ title }}</strong>
      </mdb-card-title>

      <h5 class="blue-text">
        <strong>{{ caption }}</strong>
      </h5>

      <mdb-card-text>
        {{ description }}
      </mdb-card-text>

      <mdb-card-footer class="text-muted mt-4">
        <img src="../assets/pentagon-logo.png" class="pentagon-thumb" alt="">
      </mdb-card-footer>
    </mdb-card-body>
  </mdb-card>
</template>

<script>
  import {
    mdbIcon,
    mdbCard,
    mdbView,
    mdbMask,
    mdbCardImage,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardBody
  } from 'mdbvue';

  export default {
    name: 'Album',
    props: {
      id: {
        required: true,
        type: Number | String
      },
      cover: {
        required: true,
        type: Object
      },
      title: {
        required: false,
        default: '',
        type: String
      },
      caption: {
        required: false,
        default: '',
        type: String
      },
      description: {
        required: false,
        default: '',
        type: String
      },
    },
    components: {
      mdbIcon,
      mdbCard,
      mdbView,
      mdbMask,
      mdbCardImage,
      mdbCardTitle,
      mdbCardText,
      mdbCardFooter,
      mdbCardBody
    },
    methods: {
      goToAlbum() {
        this.$router.push(`/Gallerij/Album/${this.id}`)
      }
    }
  };
</script>

<style scoped>
  .pentagon-thumb {
    height: 25px;
    width: 25px;
  }
</style>
